var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDarkGreyLike(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.10864 7.28711H1.33203V13.1784H4.10864V7.28711Z",
    fill: "#B9B9B9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2925 4.13317C11.4609 3.33378 10.9425 2.50337 10.1845 2.24608C9.81678 2.11077 9.42762 2.14106 9.10342 2.25251C8.78022 2.3636 8.47102 2.57264 8.27935 2.85966L5.7519 6.61998H5.73837V6.64012V13.8421L11.7155 13.8423C12.7158 13.8423 13.2792 13.2199 13.7079 12.5407C14.1778 11.7961 14.4834 11.0028 14.7104 10.2962C14.8153 9.96977 14.9049 9.65716 14.9851 9.37704L15.0047 9.30867C15.0913 9.00654 15.1655 8.7522 15.24 8.54423C15.4458 7.97041 15.381 7.39888 15.0547 6.96496C14.7327 6.53687 14.2076 6.31071 13.6247 6.31071H11.1452C11.0895 6.31071 11.0471 6.2882 11.0211 6.25882C10.9988 6.23347 10.9735 6.186 10.9852 6.09991L11.2925 4.13317ZM10.4234 6.97274C10.3961 6.94898 10.37 6.92383 10.3452 6.89739L10.3382 6.97487L10.4234 6.97274Z",
    fill: "#B9B9B9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.642578 7.48387C0.642578 6.90381 1.1128 6.43359 1.69284 6.43359H3.79334C4.37338 6.43359 4.8436 6.90381 4.8436 7.48387V12.7354C4.8436 13.3982 4.30634 13.9354 3.6436 13.9354H1.69284C1.1128 13.9354 0.642578 13.4652 0.642578 12.8852V7.48387ZM1.69284 7.33384C1.60997 7.33384 1.5428 7.40099 1.5428 7.48387V12.8852C1.5428 12.968 1.60997 13.0352 1.69284 13.0352H3.94338V7.48387C3.94338 7.40099 3.87621 7.33384 3.79334 7.33384H1.69284Z",
    fill: "#B9B9B9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkGreyLike);
export default __webpack_public_path__ + "static/media/dark_grey_like.3e3981dc931b2faabac7b9d6eae9502f.svg";
export { ForwardRef as ReactComponent };